import React, { useEffect } from "react";
import { RoutesComponent } from "Routes/Routes";
import { SnackbarProvider } from "notistack";
import styled from "styled-components";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useHookstate } from "@hookstate/core";
import {
    SIDENAV_GLOBAL_STATE,
    LANGUAGE_GLOBAL_STATE,
    SITELOCATION_GLOBAL_STATE,
} from "globalStore/globalStore";

import AnnouncementPopup from "commonComponents/AnnouncementPopup";
import "../src/locale/i18nextInit";
const App = () => {
    const { selectedLang } = useHookstate(LANGUAGE_GLOBAL_STATE);
    const { siteLocationGlobalData } = useHookstate(SITELOCATION_GLOBAL_STATE);

    const { subNavDataState } = useHookstate(SIDENAV_GLOBAL_STATE);

    useEffect(() => {
        document.body.removeAttribute("class");
        document.body.classList.add(`${selectedLang.get()}`);
    }, [selectedLang.get()]);

    return (
        <>
            <MainSection
                className={
                    subNavDataState.get().toUpperCase() === "MAP" ? `App for-map` : `App`
                }
            >
                {!siteLocationGlobalData.get() && <ToastContainer />}
                <SnackbarProvider maxSnack={5} autoHideDuration={10000}>
                    <RoutesComponent />
                </SnackbarProvider>
                {!siteLocationGlobalData.get() && <AnnouncementPopup />}
            </MainSection>
        </>
    );
};

export default App;

const MainSection = styled.div`
  .please-rotate {
    display: none;
  }
  /* .for-other-section-header {
        display: block;
      }
      .navbar-map-other-section {
        display: block;
      } */
  @media (min-width: 850px) {
    &.for-map {
      /* .for-other-section-header{
        display: none;
      } */
      /* .navbar-map-other-section {
        display: none;
      } */
      .navbar-map {
        position: absolute;
        right: 0;
        left: 0;
        z-index: 1;
        .header-app {
          box-shadow: none;
        }
      }
      .sidenav-wrapper {
        padding-top: 56px;
        height: 100vh;
      }
      .for-map-center-icons {
        display: inline-flex;
        width: auto;
        position: absolute;
        transform: translate(-40vw, -63px);
      }
        .for-map-bottom {
        display: inline-flex;
        width: auto;
        position: absolute;
        transform: translate(-50vw, 600px);
      }
      .for-map-filter-header {
        top: 74px;
        justify-content: flex-end;
        /* width: calc(100% - 62px); */
        left: unset;
        width: auto;
        right: 52px;
      }
      .for-map-header-left-section {
        display: flex;
        align-items: center;
        position: absolute;
        left: 0;
        z-index: 2;
        background: #fff;
        min-height: 56px;
        .logo {
          max-width: 82px;
        }
      }
      .for-map-header-right-section {
        display: flex;
        align-items: center;
        position: absolute;
        right: 0;
        z-index: 2;
        background: #fff;
         min-height: 56px;
      }
    }
  }
  @media (max-width: 1166px) {
    &.for-map {
      .for-map-center-icons {
        transform: translate(-29vw, -63px);
      }
    }
  }
  @media (max-width: 1010px) {
    &.for-map {
      .for-map-center-icons {
        transform: translate(-29vw, 0);
      }
    }
  }

  @media only screen and (max-width: 900px) and (orientation: landscape) {
    .please-rotate {
      display: flex;
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      width: 100%;
      background: var(--filter-bar-bg);
      z-index: 9999;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 20px;
      flex-direction: column;
      gap: 10px;
      svg {
        width: 100px;
        path {
          fill: #fff;
        }
      }
    }
  }

  @media only screen and (max-width: 1180px) and (orientation: landscape) {
    .please-rotate {
      display: flex;
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      width: 100%;
      background: var(--filter-bar-bg);
      z-index: 9999;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 20px;
      flex-direction: column;
      gap: 10px;
      svg {
        width: 100px;
        path {
          fill: #fff;
        }
      }
    }
  }
  @media only screen and (width: 1024px) and (height: 768px) and (orientation: landscape) {
    .please-rotate {
      display: none;
    }
  }

  .azEditCursorDefault,
  .azEditCursorDefault * {
    cursor: default !important; 
  }

  .azEditCursorAlias,
  .azEditCursorAlias * {
    cursor: alias !important; 
  }

  .azEditZoomLevel18,
  .azEditZoomLevel18 * {
    cursor: url(/assets/cursor/guideHaloZoomLevel18-32.cur), crosshair !important; 
  }
  .azEditZoomLevel19,
  .azEditZoomLevel19 * {
    cursor: url(/assets/cursor/guideHaloZoomLevel19-64.cur), crosshair !important; 
  }

  .azEditZoomLevel20,
  .azEditZoomLevel20 * {
    cursor: url(/assets/cursor/guideHaloZoomLevel20-128.cur), crosshair !important; 
  }

  .azCreateZoomLevel18,
  .azCreateZoomLevel18 * {
    cursor: url(/assets/cursor/guideHaloCreateZoomLevel18-32.cur), crosshair !important; 
  }

  .azCreateZoomLevel19,
  .azCreateZoomLevel19 * {
    cursor: url(/assets/cursor/guideHaloCreateZoomLevel19-64.cur), crosshair !important; 
  }

  .azCreateZoomLevel20,
  .azCreateZoomLevel20 * {
    cursor: url(/assets/cursor/guideHaloCreateZoomLevel20-128.cur), crosshair !important; 
  }
`;
